export default function Fragment(props) {
  return props.children;
}